export function setDocumentFile(state, data) {
    let extension = data.name.split(".");
    let file = {
        id: null,
        name: data.name,
        extension: extension[extension.length - 1],
        path: "",
        size: data.size,
        sent: false,
        document_id: state.params.document_id
    };

    state.params.files.push(file);

    state.document_files_new.push(data);
}

export function setFiles(state, files){
    state.params.files = files
}

export function resetDocumentFiles(state){
    state.document_files_new    = []
    state.document_files_delete = []
}


// WEBPACK FOOTER //
// ./src/modules/modal-attachments/mutations.js